export default __webpack_public_path__ + "static/media/natureforesttreesfog.cf72cded.png";